// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const DeleteIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path d="M17.06 4.9h3.42c.54 0 .97.43.97.97 0 .53-.43.97-.97.97H3.52c-.54 0-.97-.44-.97-.97 0-.54.43-.98.97-.98h3.34c.29 0 .54-.2.6-.48l.31-1.43c.24-.89 1.01-1.48 1.89-1.48h4.59c.88 0 1.65.6 1.88 1.44l.32 1.46c.06.29.31.5.6.5" />
      <path
        fillRule="evenodd"
        d="M4.74 8.53h14.47c.53 0 .85.33.82.86q-.09 1.23-.2 2.44c-.06.78-.61 6.96-.69 7.7-.1.96-.47 1.8-1.29 2.4q-.8.54-1.77.55c-1.69.03-7.12.03-8.14 0-1.55-.02-2.72-.97-3.02-2.5-.1-.48-.83-8.84-.9-9.74l-.03-.28-.04-.6c-.02-.48.3-.83.8-.83"
        clipRule="evenodd"
        opacity=".5"
      />
      <path
        fillRule="evenodd"
        d="M14.78 18.04c.32-.32.32-.84 0-1.17l-1.54-1.53 1.54-1.52c.32-.32.32-.85 0-1.17-.33-.32-.85-.32-1.18 0l-1.53 1.52-1.52-1.52c-.33-.32-.84-.32-1.18 0-.32.32-.32.85 0 1.17l1.53 1.52-1.53 1.53c-.32.33-.32.85 0 1.17.34.33.85.33 1.18 0l1.52-1.53 1.53 1.53q.25.25.58.24.34 0 .6-.24"
        clipRule="evenodd"
      />
    </g>
  </SvgIcon>
);

export default DeleteIcon;
